export const SettingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10.667 2.5c.351 0 .665.22.784.552l.423 1.179a.84.84 0 0 0 .369.44l1.255.725c.171.098.37.133.565.098l1.233-.222a.83.83 0 0 1 .87.403l.667 1.15a.83.83 0 0 1-.083.955l-.81.957a.83.83 0 0 0-.197.538v1.45c0 .197.07.388.198.538l.81.957c.226.269.259.65.082.955l-.666 1.15a.83.83 0 0 1-.87.403l-1.234-.222a.83.83 0 0 0-.564.098l-1.256.725a.84.84 0 0 0-.368.44l-.423 1.18a.83.83 0 0 1-.785.551H9.333a.83.83 0 0 1-.784-.552l-.423-1.179a.84.84 0 0 0-.368-.44l-1.256-.725a.83.83 0 0 0-.564-.098l-1.234.222a.83.83 0 0 1-.87-.403l-.667-1.15a.83.83 0 0 1 .083-.955l.81-.957a.83.83 0 0 0 .197-.538v-1.45a.83.83 0 0 0-.198-.538l-.8-.957a.83.83 0 0 1-.084-.955l.667-1.15a.83.83 0 0 1 .87-.403l1.233.222c.194.035.394 0 .564-.098l1.257-.725c.17-.1.3-.255.367-.44l.424-1.18a.83.83 0 0 1 .776-.551z"
    ></path>
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M10 8.333a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333"
    ></path>
  </svg>
);
